import { render, staticRenderFns } from "./CambiarContrasena.vue?vue&type=template&id=49a84322&scoped=true"
import script from "./CambiarContrasena.vue?vue&type=script&lang=js"
export * from "./CambiarContrasena.vue?vue&type=script&lang=js"
import style0 from "./CambiarContrasena.vue?vue&type=style&index=0&id=49a84322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a84322",
  null
  
)

export default component.exports